module cluster_ui {

   export class ClusterCpuUtilizationPortletController implements angular.IComponentController {

      public meters: any[] = [];
      public maxCapacityValue: string = "";
      public resourcesData: any = {};

      public static $inject = ["$scope", "dataService", "clusterUtilizationService",
         "$controller"];

      constructor(protected $scope: angular.IScope, private dataService: any,
                  protected clusterUtilizationService: ClusterUtilizationService,
                  public $controller: angular.IControllerService) {
         angular.extend(this, $controller("GenericPortletController", {$scope: $scope}));

         $scope.$watch("data", (data: any) => {
            if (data) {
               this.meters = this.clusterUtilizationService.getCpuMetersData(data);
               this.maxCapacityValue = data.cpuCapacityFormatted;
               this.resourcesData =
                     this.clusterUtilizationService.buildCpuPropertyViewData(data);
            }
         });
      }
   }

   angular.module("com.vmware.vsphere.client.cluster")
         .controller("ClusterCpuUtilizationPortletController",
               ClusterCpuUtilizationPortletController);
}
